import UserToDoList from "../owner/UserToDoList";
import WaagChart from "../owner/WaagChart";
import ClinicianHoursChart from "../owner/ClinicianHoursChart";
import ConflictManagement from "../admin/ConflictManagement";

export default function OfficeManagerDashboardComponent({ onAppointmentClick, onReschedule, onWideSidePanelClose }) {
  return (
    <div className="w-full space-y-6 pb-20">
      {/* Conflict Management Section */}
      <div className="bg-white rounded-lg shadow">
        <ConflictManagement onAppointmentClick={onAppointmentClick} />
      </div>

      {/* Main Dashboard Content */}
      <div>
        <WaagChart />
        <ClinicianHoursChart />
        <UserToDoList />
      </div>
    </div>
  );
}
